import * as types from './types';

export const setIsAuthorized = (isAuthorized) => ({
  type: types.SET_IS_AUTHORIZED,
  payload: isAuthorized,
});
